export default {
	list: 'Program',
	grid: {
		gridId: 'programGrid',
		checkbox: true,
		edit: true,
		delete: false,
		height: 300,
		groupable: true,
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		Alias: {
			class: 'value',
			dataName: 'Alias',
			type: 'string',
			title: 'Project Name',
			width: 150,
			hidden: false,
			readOnly: false
		},
		ProgramID: {
			class: 'value',
			dataName: 'ProgramID',
			type: 'number',
			title: 'Program ID',
			width: 120,
			hidden: false,
			readOnly: false
		},
		Title: {
			class: 'value',
			dataName: 'Title',
			type: 'string',
			title: 'Program Name',
			width: 200,
			hidden: false,
			readOnly: false,
			//template:'<a href="/report/program/#:Id #">#:Title #</a>' 
		},
		InvestmentInvestmentID: {
			class: "lookup",
			dataName: 'Investment/InvestmentID',
			type: 'string',
			title: 'Investment ID',
			width: 130,
			hidden: false,
			readOnly: true
		},
		InvestmentId: {
			class: 'lookup',
			dataName: 'InvestmentId',
			type: 'number',
			title: 'Investment Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		InvestmentTitle: {
			class: "lookup",
			dataName: 'Investment/Title',
			type: 'string',
			title: 'Investment',
			width: 150,
			hidden: false,
			readOnly: true
		},
		EIN: {
			class: 'value',
			dataName: 'EIN',
			type: 'string',
			title: 'EIN',
			width: 100,
			hidden: false,
			readOnly: false
		},
		FormationDate: {
			class: 'value',
			dataName: 'FormationDate',
			type: 'date',
			title: 'Formation Date',
			width: 100,
			hidden: true,
			readOnly: false
		},
		// FinalCloseDate: {
		// 	class: 'value',
		// 	dataName: 'FinalCloseDate',
		// 	type: 'date',
		// 	title: 'Final Close Date',
		// 	width: 100,
		// 	hidden: true,
		// 	readOnly:false
		// },
		IncomeSource: {
			class: 'choice',
			dataName: 'IncomeSource',
			multi: true,
			type: 'string',
			title: 'Income Source',
			width: 100,
			hidden: true,
			readOnly: false
		},
		StateSource: {
			class: 'choice',
			dataName: 'StateSource',
			multi: true,
			type: 'string',
			title: 'State Source',
			width: 100,
			hidden: true,
			readOnly: false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: false,
			readOnly: false
		},
		AllocationStatus: {
			class: "value",
			dataName: 'AllocationStatus',
			type: 'string',
			title: 'AllocationStatus',
			width: 100,
			hidden: true,
			readOnly: false
		},
		AllocationDate: {
			class: "value",
			dataName: 'AllocationDate',
			type: 'date',
			title: 'AllocationDate',
			width: 100,
			hidden: true,
			readOnly: false
		},
		InitialAwardDate: {
			class: "value",
			dataName: 'InitialAwardDate',
			type: 'date',
			title: 'InitialAwardDate',
			width: 100,
			hidden: true,
			readOnly: false
		}
	}
}